<template>
  <span :class="classes" v-if="show">
    ({{ sign }}{{ delta }}%)
  </span>
</template>

<script>
export default {
  props: {
    current: Number,
    previous: Number,
  },
  computed: {
    classes() {
      return this.sign === '+' ? 'positive' : 'negative';
    },
    delta() {
      if (! this.current || ! this.previous) {
        return;
      }

      return ((this.current / this.previous ) * 100 - 100).toFixed();
    },
    show () {
      return this.current && this.previous;
    },
    sign() {
      return this.delta >= 0 ? '+' : '';
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/variables';

span {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 9999px;
  vertical-align: middle;
}

.positive {
  color: #047857;
  background-color: #ecfdf5;
}

.negative {
  color: #b91c1c;
  background-color: #fef2f2;
}
</style>
